<template>
  <div
    class="select-pop"
    :class="{ open: show }"
    :style="popStyle"
    @click.stop="handleClosePanel"
  >
    <div v-if="show" class="panel">
      <div
        v-for="item in dropData"
        :key="item.key"
        class="panel-item"
        :class="{ selected: item.key === value }"
        @click="handleSelectItem(item.key)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectPop",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    show: { type: Boolean },
    popStyle: {
      type: String
    },
    value: {
      type: String
    },
    dropData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      showSelectPanel: false
    };
  },
  methods: {
    handleClosePanel() {
      this.$emit("close");
    },
    handleSelectItem(key) {
      this.$emit("change", key);
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.select-pop {
  position: fixed;
  top: 0;
  width: 100%;
  min-width: 15%;
  display: flex;
  justify-content: flex-start;
  .panel {
    max-height: 2.8rem;
    overflow-x: hidden;
    margin: 0 0.48rem;
    margin-top: 1.8rem;
    overflow-y: auto;
    z-index: 9;
    background: #ffffff;
    border: 0.02rem solid #dddddd;
    transition: max-height 0.15s;

    box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.14);
    border-radius: 0.02rem;
    .panel-item {
      font-size: 0.3rem;
      color: #4a4a4a;
      padding: 0.2rem 0.36rem;
      &:not(:last-child) {
        border-bottom: 0.02rem solid #dddddd;
      }

      &.selected {
        color: #ffffff;
        background: #f07b24;
      }
    }
  }
}
</style>
